export const environment = {
  production: false,
  apiUrl: 'https://stage.mobbsign.mobbeel.com'
};
